const isDev = () => window.location.href.includes('tissuu.com');
declare const ENV: { [key: string]: string };

/* eslint-disable node/no-process-env */
export const getEnv = (name: string): string => {
    if (name in ENV) {
        return ENV[name] as string;
    } else {
        return '';
    }
};

// eslint-disable-next-line no-console
console.log(`ENV`, ENV);

// https://issuu.zendesk.com/admin/objects-rules/tickets/ticket-fields  Issuu Account Username  5779660692507
export const ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_USER =
    getEnv('ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_USER') ||
    (isDev() ? '5779660692507' : '23671203');

export const ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_AGENT =
    getEnv('ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_AGENT') ||
    (isDev() ? '5779654640283' : '47056527');

export const HOST_PINGBACK_PUBLICNAME =
    getEnv('HOST_PINGBACK_PUBLICNAME') || (isDev() ? 'pingback.tissuu.com' : 'pingback.issuu.com');

export const ZD_SERVICES_WIDGET_KEY =
    getEnv('ZD_SERVICES_WIDGET_KEY') ||
    (isDev() ? '91ca6d99-08fe-4384-8221-ce497d3a084d' : '852baae8-7ef7-4b17-a6ba-58ffc2aed13b');

export const ZVA_SERVICES_APIKEY = getEnv('ZVA_SERVICES_APIKEY') || 'eimUZFrrSS-kuQvO5OktDA';
